import React from 'react';
import { RepeatIcon } from 'lucide-react';
import { SectionHeader } from './SectionHeader';
import { HabitCard } from '../habits/HabitCard';
import { EmptyState } from '../ui/EmptyState';
import { useAppData } from '../../contexts/AppDataContext';
import { getStreak } from '../../utils/habits';
export function TodayHabitsSection() {
  const {
    habits,
    toggleHabitToday
  } = useAppData();
  return <section data-id="element-80" data-mp="1h8xvv0s45amd">
      <SectionHeader icon={RepeatIcon} iconClassName="bg-teal-50 text-teal-600" title="Today's habits" linkTo="/habits" data-id="element-81" data-mp="1h73bpooo1mjc" />
      {habits.length === 0 ? <EmptyState icon={RepeatIcon} title="No habits yet" description="Add one from the Habits tab." data-id="element-82" data-mp="1r6c9ytqkdnbi" /> : <div className="space-y-2" data-id="element-83" data-mp="1v8fppuk9ne2l">
          {habits.slice(0, 4).map(habit => <HabitCard key={habit.id} habit={habit} streak={getStreak(habit)} onToggleToday={() => toggleHabitToday(habit.id)} compact data-id="element-84" data-mp="3sxp5wtak0kvf" />)}
        </div>}
    </section>;
}